/*
 *
 * MicrosoftVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_MICROSOFT } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const microsoftVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_MICROSOFT.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_MICROSOFT.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_MICROSOFT.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default microsoftVerifyReducer;
